export default __webpack_public_path__ + "static/media/Lautaro.f359019c.jpg";